module.exports = __webpack_public_path__ + "static/media/sagar-logo.205e4280.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/sagar-logo.jpg
 ** module id = 774
 ** module chunks = 0
 **/